import { render, staticRenderFns } from "./basicPriceTrends.vue?vue&type=template&id=0b0ba912&scoped=true"
import script from "./basicPriceTrends.vue?vue&type=script&lang=js"
export * from "./basicPriceTrends.vue?vue&type=script&lang=js"
import style0 from "./basicPriceTrends.vue?vue&type=style&index=0&id=0b0ba912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ba912",
  null
  
)

export default component.exports